import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrl: './image-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImagePickerComponent),
      multi: true,
    },
  ],
})
export class ImagePickerComponent implements ControlValueAccessor {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @Input() formGroup: FormGroup;
  @Input() formControlName = '';
  @Input() imageFormControlName = '';
  @Input() label = '';

  value: string;

  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.formGroup.controls[this.imageFormControlName].setValue(
          reader.result,
        );
        this.formGroup.controls[this.imageFormControlName].markAsDirty();
        this.formGroup.markAsDirty();
        this.formGroup.patchValue({ [this.formControlName]: file });
      };
      reader.readAsDataURL(file);
    }
  }

  deleteFile() {
    this.formGroup.controls[this.imageFormControlName].setValue('');
    this.fileInput.nativeElement.value = '';
    this.formGroup.controls[this.imageFormControlName].markAsDirty();
    this.formGroup.markAsDirty();
    this.formGroup.patchValue({ [this.formControlName]: null });
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value); // Notify the form about the change
    this.onTouched(); // Mark as touched
  }
}
